import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { CREATE_CUSTOMER } from '../../../apollo';
import { Customer } from '@hiwaldo/sdk/interfaces';
import { useCreateCartEffect } from '../..';
import { CheckoutCustomerInput } from '../../../../interfaces';
import { useDispatch } from 'react-redux';
import { customerSlice } from '../../..';

type CreatePatientEffectReturn = {
  createPatient: (data: CheckoutCustomerInput) => void;
  loading: boolean;
  success: boolean;
  error: string | undefined;
};

export const useCreatePatientEffect = (
  callback?: (data?: any) => void
): CreatePatientEffectReturn => {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);

  const { createCart } = useCreateCartEffect(callback);
  const updateCartCustomer = (authedCustomer: Customer) => {
    dispatch(customerSlice.actions.update(authedCustomer));
    createCart(undefined, undefined, +authedCustomer.id);
    setSuccess(true);
  };

  const [doCreateCustomer, { loading, error }] = useMutation(CREATE_CUSTOMER, {
    onCompleted: (data: any) => {
      updateCartCustomer(data.createCustomer);
    },
  });

  const createPatient = (data: CheckoutCustomerInput): void => {
    const variables = { data };

    doCreateCustomer({ variables }).then();
  };

  return { createPatient, loading, success, error: error?.message };
};
